import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EcPoliciesService } from '../ec-policies.service';
import { GLOBAL } from 'src/app/app.globals';

@Component({
  selector: 'app-ec-policy-details',
  templateUrl: './ec-policy-details.component.html',
  styleUrls: ['./ec-policy-details.component.css']
})
export class EcPolicyDetailsComponent implements OnInit {
  @Input() ecPolicyCode: number;
  @Input() requireType: number;
  @Output() closeModal = new EventEmitter<void>();

  ecPolicyDetails: any = {};
  loading = true;
  showGrid = true;

  documentColDefs = [
    { headerName: 'Document Name', field: 'DocumentName', sortable: true, width: 150, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Document Type', field: 'DocumentType', sortable: true, width: 120, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Uploaded By', field: 'UploadedBy', sortable: true, width: 120, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Size', field: 'size', sortable: true, width: 80, cellStyle: { 'text-align': 'center' } },
    { headerName: 'Uploaded Date', field: 'UploadedDate', sortable: true, width: 120, cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => params.value ? new Date(params.value).toLocaleDateString() : '-' },
    { headerName: 'Is Verify?', field: 'IsVerify', sortable: true, width: 90, cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => params.value ? 'Yes' : 'No' },
    { headerName: 'Verify Date', field: 'VerifyDate', sortable: true, width: 120, cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => params.value ? new Date(params.value).toLocaleDateString() : '-' },
    { headerName: 'Verify By', field: 'VerifyBy', sortable: true, width: 120, cellStyle: { 'text-align': 'center' } },
    { 
      headerName: 'View', 
      field: 'DocLink',
      sortable: false,
      width: 80,
      cellStyle: { 'text-align': 'center' },
      cellRenderer: (params) => {
        if (params.data && params.data.DocLink) {
          return '<a href="' + GLOBAL.DOC_URL + params.data.DocLink + '" target="_blank"><i class="fa fa-eye" style="cursor: pointer; color: #4fc5ea;"></i></a>';
        }
        return '-';
      }
    }
  ];

  constructor(private ecPolicyService: EcPoliciesService) { }

  ngOnInit() {
    if (this.ecPolicyCode) {
      this.getEcPolicyDetails();
    }
  }

  getEcPolicyDetails() {
    const payload = {
      Filter: {
        ECPolicy_Code: this.ecPolicyCode,
        RequireType: this.requireType,
        ActionType: 1,
        UserId: JSON.parse(localStorage.getItem('UserId')) || 142
      }
    };

    this.ecPolicyService.getEcPolicyDetails(payload).subscribe(
      (response: any) => {
        if (response && response.Table1 && response.Table1.length > 0) {
          this.ecPolicyDetails = response.Table1[0];
          this.ecPolicyDetails.DocumentImageMasterViewModals = response.Table2 || [];
        }
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching EC Policy details:', error);
        this.loading = false;
      }
    );
  }

  close() {
    this.closeModal.emit();
  }
}